/**
 * Capitalises the first letter of every word while leaving the rest of each word
 * untouched, so capitals typed by the user are preserved.
 *
 * "ram kumar" -> "Ram Kumar", "ram kUMAR" -> "Ram KUMAR", "RAM" -> "RAM".
 */
export function capitalizeName(value?: string | null): string | null {
	if (typeof value !== 'string') {
		return null;
	}

	let cleaned = value.trim().replace(/\s+/g, ' ');

	if (!cleaned) {
		return cleaned;
	}

	// Words start at the beginning of the string or after whitespace/hyphen.
	// toUpperCase() is a no-op for characters that are already capital or not letters.
	return cleaned.replace(/(^|[\s-])(\S)/g, function (match, boundary, firstChar) {
		return boundary + firstChar.toUpperCase();
	});
}

export default capitalizeName;
